import ContentLoader from 'react-content-loader'

export const Skeleton: typeof ContentLoader = props => {
    return (
        <ContentLoader
            backgroundColor="var(--color-neutral-100)"
            data-slot="skeleton"
            foregroundColor="var(--color-neutral-200)"
            height="100%"
            width="100%"
            {...props}
        >
            <rect height="100%" rx="4" ry="4" width="100%" x="0" y="0" />
        </ContentLoader>
    )
}
Skeleton.displayName = 'Skeleton'
